import axios from "axios";
import Links from "@/shared/constants/Links";

const ProgrammePathways = {
    list: async (params = {}) => {
        return axios.get(Links.programmePathways.base, {params});
    },

    listActiveBranches: async (programmeId) => {
        return axios.get(`${Links.programmePathways.programmes}/${programmeId}/branches`);
    },

    create: async (data) => {
        return axios.post(Links.programmePathways.base, data);
    },

    update: async (pathwayId, data) => {
        return axios.put(`${Links.programmePathways.base}/${pathwayId}`, data);
    },

    remove: async (pathwayId) => {
        return axios.delete(`${Links.programmePathways.base}/${pathwayId}`);
    },

    previewTransition: async (data) => {
        return axios.post(`${Links.programmePathways.transitions}/preview`, data);
    },

    executeTransition: async (batchId) => {
        return axios.post(Links.programmePathways.transitions, {batchId});
    },

    getTransitionBatch: async (batchId) => {
        return axios.get(`${Links.programmePathways.transitions}/${batchId}`);
    },

    getStudentHistory: async (studentId) => {
        return axios.get(`${Links.programmePathways.students}/${studentId}/programme-history`);
    },
};

export default ProgrammePathways;
